import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const SupportPage = ({ onBack }) => {
  const { t } = useTranslation();
  const [message, setMessage] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim()) {
      // Логика отправки сообщения (пока заглушка)
      console.log('Отправлено сообщение:', {
        message,
        email: showContactForm ? email : undefined,
        phone: showContactForm ? phone : undefined
      });
      setIsSubmitted(true);
      
      // Сброс через 3 секунды
      setTimeout(() => {
        setIsSubmitted(false);
        setMessage('');
        setEmail('');
        setPhone('');
        setShowContactForm(false);
      }, 3000);
    }
  };

  const handleBackToMain = () => {
    if (onBack) {
      onBack();
    }
  };

  return (
    <div className="support-page">
      <div className="support-container">
        {/* Заголовок */}
        <div className="support-header">
          <h1 className="support-title">{t('support.title', 'МЫ ВСЕГДА РАДЫ ПОМОЧЬ!')}</h1>
          <p className="support-subtitle">
            {t('support.subtitle', 'Тут можно задать вопрос сотруднику поддержки')}
          </p>
        </div>

        {/* Форма поддержки */}
        <div className="support-form-container">
          {isSubmitted ? (
            <div className="success-message">
              <div className="success-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
              </div>
              <h3>Сообщение отправлено!</h3>
              <p>Наш специалист свяжется с вами в ближайшее время</p>
            </div>
          ) : (
            <form className="support-form" onSubmit={handleSubmit}>
              {/* Блок с текстовым полем */}
              <div className="message-block">
                <div className="block-header">
                  <span className="block-title">
                    {t('support.messageBlock', 'Написать текст')}
                  </span>
                </div>
                <div className="message-input-container">
                  <textarea
                    className="message-textarea"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder={t('support.placeholder', 'Опишите вашу проблему или задайте вопрос...')}
                    rows={8}
                    maxLength={1000}
                    required
                  />
                  <div className="textarea-footer">
                    <span className="char-counter">
                      {message.length}/1000 символов
                    </span>
                  </div>
                </div>
              </div>

              {/* Контактная информация (опционально) */}
              <div className="contact-info-toggle">
                <button
                  type="button"
                  className="toggle-contact-btn"
                  onClick={() => setShowContactForm(!showContactForm)}
                >
                  <span className="toggle-icon">
                    {showContactForm ? '−' : '+'}
                  </span>
                  <span className="toggle-text">
                    {showContactForm ? 'Скрыть контактные данные' : 'Указать контактные данные для ответа'}
                  </span>
                </button>
                
                {showContactForm && (
                  <div className="contact-fields">
                    <div className="contact-field-group">
                      <label className="contact-label">
                        <span className="label-text">Email</span>
                        <input
                          type="email"
                          className="contact-input"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="example@mail.ru"
                        />
                      </label>
                      <label className="contact-label">
                        <span className="label-text">Телефон</span>
                        <input
                          type="tel"
                          className="contact-input"
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                          placeholder="+7 (900) 123-45-67"
                        />
                      </label>
                    </div>
                    <p className="contact-note">
                      Если не указать контактные данные, ответ будет доступен в этом же разделе
                    </p>
                  </div>
                )}
              </div>

              {/* Кнопка отправки */}
              <div className="submit-block">
                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={!message.trim()}
                >
                  <span className="submit-btn-text">
                    {t('support.sendButton', 'Отправить')}
                  </span>
                  <span className="submit-btn-icon">→</span>
                </button>
                <p className="submit-note">
                  Ответ обычно приходит в течение 1-2 рабочих дней
                </p>
              </div>
            </form>
          )}
        </div>

        {/* Кнопка возврата на главную */}
        <div className="support-footer">
          <button 
            className="back-to-main-btn"
            onClick={handleBackToMain}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="19" y1="12" x2="5" y2="12"></line>
              <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
            {t('mainPage.back', 'На главную')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SupportPage;